import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RetentionCenter } from './pages/RetentionCenter';
import { LoanDetail } from './pages/LoanDetail';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<RetentionCenter data-id="element-3" />} data-id="element-2" />
        <Route path="/loan/:loanId" element={<LoanDetail data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}